import * as React from 'react';
import { DateUtils } from '@shared/utils/DateUtils';
import { DateTimeSpan } from '@shared/ui-react/UtilComponents';

/*interface ITrackPoint {
    lat: number;
    lon: number;
    t: any;
}*/

export class TruckTripInfoCard extends React.Component<{
    trips: ITruckTrip[],
    wholeTableLength?: number,
}> {
    render() {
        const { trips, wholeTableLength } = this.props;

        if (!!wholeTableLength || trips.length > 1) {
            return <div className='padded no-break-text'>{__('trucks.showing_n_trip_paths', wholeTableLength || trips.length)}</div>;
        }

        const trip = trips[0];
        return TruckTripInfoDetails(trip);
    }
}

export const TruckTripInfoDetails = (trip: Partial<ITruckTrip>) => {
    const totalTimeInSeconds = ((trip?.endDate || 0) - (trip?.startDate || 0)) / 1000;

    return (
        <div>
            {!!trip && <div className='padded no-break-text'>
                <h4>{trip.vehicleName}</h4>
                <div className='flex-row'>
                    <div>
                        <b>{__('trucks.trips.table_material')}</b>: <span>{trip.material}</span><br/>
                        <b>{__('trucks.trips.table_volume')}</b>: {trip.volume}<br/>
                        <b>{__('trucks.trips.table_ttime')}</b>: {DateUtils.secondsToDateTime(totalTimeInSeconds)}<br/>
                        <b>{__('trucks.trips.table_distance')}</b>: {(trip.distance / 1000).toFixed(3)} KM<br/>
                    </div>
                    <div style={{ marginLeft: 20 }}>
                        <b>{__('trucks.trips.start_date')}</b>: <DateTimeSpan timestamp={trip.startDate}/><br/>
                        <b>{__('trucks.trips.end_date')}</b>: <DateTimeSpan timestamp={trip.endDate}/><br/>
                        <b>{__('trucks.trips.table_load')}</b>: {trip.startingAreaName}<br/>
                        <b>{__('trucks.trips.table_unload')}</b>: {trip.endingAreaName}
                    </div>
                </div>
            </div>}
        </div>
    );
}
